import { gql } from '@apollo/client'

import PriceFragment from '@Queries/cms/fragments/Price.fragment'

export default gql`
  ${PriceFragment}

  fragment ProductTile on Product {
    id
    name
    url
    primaryAsset: asset(tag: "primary") {
      url
    }
    masterVariant {
      price {
        ...PriceFragment
      }
    }
  }
`
